<script setup lang="ts">
import { useToast } from '@/shared/composables/useToast';

const { state } = useToast();
</script>

<template>
  <div
    class="pointer-events-none fixed bottom-[26px] left-1/2 z-[100] rounded-[10px] border bg-popover px-5 py-3 text-[13px] font-semibold text-foreground shadow-[0_14px_40px_rgba(0,0,0,0.5)] transition-all duration-[250ms]"
    :class="[
      state.visible ? '-translate-x-1/2 translate-y-0 opacity-100' : '-translate-x-1/2 translate-y-5 opacity-0',
      state.error ? 'border-crit' : 'border-input',
    ]"
  >
    {{ state.message }}
  </div>
</template>
